<p>assume-role works!</p>
